import { Component, Input } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';

import { AppError } from 'src/app/core/models/api-error';

/**
 * Form-level failure, held on the page until the user acts on it.
 *
 * The HTTP interceptor already toasts these, but a toast fades while someone
 * is still retyping. MFA's failure modes -- wrong code, expired challenge, too
 * many attempts -- all need to stay readable across that retype, which a toast
 * cannot do.
 *
 * It lives beside `auth-layout` rather than in the login feature so
 * forget-password and reset-password can adopt it without moving it.
 */
@Component({
  selector: 'ui-auth-error-banner',
  standalone: true,
  imports: [NgIf, NgFor],
  templateUrl: './auth-error-banner.component.html',
  styleUrls: ['./auth-error-banner.component.scss'],
})
export class AuthErrorBannerComponent {
  @Input() error: AppError | null = null;

  /** Always a list, so the template has one shape to render. */
  get messages(): string[] {
    const messages = this.error?.messages;
    if (!messages) {
      return [];
    }
    return (Array.isArray(messages) ? messages : [messages]).filter((m) => !!m);
  }
}
